import React from "react";
import type { ForwardedRef } from "react";
import { clsx } from "clsx";

import { Box } from "../Box/Box";
import type { ButtonVariantProps } from "./Button.css";
import { button } from "./Button.css";
import type { BoxProps, NavigationalElements } from "../Box/Box";
import { Text } from "../Text/Text";

type Props<AS extends NavigationalElements = "button"> = BoxProps<AS> &
  ButtonVariantProps & { ref?: ForwardedRef<HTMLElement> };

export const DeprecatedBandCButton = React.forwardRef(function Button<
  AS extends NavigationalElements = "button"
>(props: Props<AS>, ref: ForwardedRef<HTMLElement>) {
  const {
    children,
    as = "button",
    className,
    variant,
    fullWidth,
    ...rest
  } = props;

  const variantClassName = button({ variant, fullWidth });
  const boxProps = rest as BoxProps<typeof as>;

  return (
    <Box
      {...boxProps}
      as={as}
      className={clsx(variantClassName, className)}
      ref={ref}
    >
      <Text as="span" color="current" variant="h2">
        {children}
      </Text>
    </Box>
  );
});
